import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import type { CompanyRegistryEvent } from "../../../api/client.ts";
import FormattedDate from "../../../components/FormattedDate.tsx";
import SectionCard from "../../../components/SectionCard.tsx";
import ScrollTable from "../../../components/table/ScrollTable.tsx";
import { KIND_LABELS } from "../registryEventKinds.ts";

// Where each source's events come from, for the attribution line.
const SOURCE_CREDITS: Record<string, string> = {
  prh_notices: "Patentti- ja rekisterihallitus (PRH), CC BY 4.0",
  brreg_kunngjoringer: "Brønnøysundregistrene, NLOD",
};

// What happened to the company: register notices (what changed and when) and
// the events we derive from its accounts and hiring.
export default function RegistryEventsCard({ events }: { events: CompanyRegistryEvent[] }) {
  const credits = [...new Set(events.map((e) => SOURCE_CREDITS[e.source]).filter(Boolean))];
  return (
    <SectionCard title="Company events">
      <ScrollTable>
        <TableHead>
          <TableRow>
            <TableCell>Registered</TableCell>
            <TableCell>Changes</TableCell>
            <TableCell>Entry codes</TableCell>
            <TableCell>Record</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {events.map((e) => (
            <TableRow key={e.id}>
              <TableCell sx={{ whiteSpace: "nowrap" }}>
                <FormattedDate value={e.registered_on} />
              </TableCell>
              <TableCell>
                <Stack direction="row" spacing={0.5} useFlexGap sx={{ flexWrap: "wrap" }}>
                  {e.kinds.map((k) => (
                    <Chip key={k} size="small" label={KIND_LABELS[k] ?? k} />
                  ))}
                </Stack>
                {e.title && (
                  <Typography variant="caption" sx={{ display: "block", mt: 0.5 }}>
                    {e.source_url ? (
                      <a href={e.source_url} target="_blank" rel="noopener noreferrer">
                        {e.title}
                      </a>
                    ) : (
                      e.title
                    )}
                  </Typography>
                )}
              </TableCell>
              <TableCell>{e.entry_codes.join(", ")}</TableCell>
              <TableCell>{e.record_number}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </ScrollTable>
      {credits.length > 0 && (
        <Typography variant="caption" sx={{ color: "text.secondary", display: "block", mt: 1 }}>
          Source: {credits.join("; ")}
        </Typography>
      )}
    </SectionCard>
  );
}
